import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

interface FeeRates {
  platformTakeRate: number;
  ccRate: number;
}

export function useFeeRates() {
  return useQuery<FeeRates>({
    queryKey: ["feeRates"],
    queryFn: () => apiFetch<FeeRates>("/config/fee-rates"),
    staleTime: Infinity,
  });
}
